import React, { useEffect, useState, useCallback } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Header from "./components/common/Header/index";
import Footer from "./components/common/Footer";
import Home from "./pages/Home/index";
import Shoppingcart from "./pages/Shoppingcart";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Thankyou from "./pages/Thankyou";
import Checkout from "./pages/Checkout";
import Singleproduct from "./pages/Singleproduct";
import Pagenotfound from "./pages/Pagenotfound";
import Contact from "./pages/Contact";
import Loginsignup from "./pages/Loginsignup";
import ForgotPassword from "./pages/ForgotPassword";
import OtpVerification from "./pages/OtpVerification";
import ResetPassword from "./pages/ResetPassword";
import Userprofile from "./pages/Userprofile/index.jsx";
import Lollipop from "./pages/Lollipop";
import Candy from "./pages/Candy";
import Toffee from "./pages/Toffee";
import Premia from "./pages/Premia";
import ProfilePage from "./pages/ProfilePage/index.jsx";
import OrderDetails from "./pages/OrderDetails/index.jsx";
import Cancellation from "./pages/Cancellation/index.jsx";
import RakhiSpecialCombo from "./pages/rakhi-special-combo/indix.js"; // Import the Rakhi Special Combo page

import Preloader from "./pages/Preloader";
import AOS from "aos";
import "aos/dist/aos.css";

// Layout component to conditionally render header and footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <>
      {!isLoginPage && <Header />}
      {children}
      {!isLoginPage && <Footer />}
    </>
  );
};

function App() {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);

  // Fetch products
  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch("https://derbyb.ritaz.in/api/products", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch products');
      }

      const data = await response.json();
      setProducts(data.products || []);
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to load products. Retrying...");
      // Retry the request after a brief delay
      setTimeout(fetchProducts, 5000);
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    fetchProducts();

    AOS.init({
      duration: 1000,
      once: false,
      mirror: false,
      throttleDelay: 99,
      debounceDelay: 50,
    });

    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        AOS.refresh();
      }
      lastScrollY = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
      AOS.refreshHard();
    };
  }, [fetchProducts]);

  // Filter products by category
  const candyProducts = products.filter(p => p.category === "Candy");
  const toffeeProducts = products.filter(p => p.category === "Toffee");
  const lollipopProducts = products.filter(p => p.category === "Lollipop");
  const premiaProducts = products.filter(p => p.category === "Premia");
  const rakhiSpecialComboProducts = products.filter(p => p.category === "diwali-special-combo");

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <Router>

          <Routes>
            <Route path="/" element={<Layout><Home products={products} loading={loading} error={error} /></Layout>} />
            <Route path="/cart" element={<Layout><Shoppingcart /></Layout>} />
            <Route path="/terms" element={<Layout><Terms /></Layout>} />
            <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
            <Route path="/order-success" element={<Layout><Thankyou /></Layout>} />
            <Route path="/checkout" element={<Layout><Checkout /></Layout>} />
            <Route path="/single-product" element={<Layout><Singleproduct /></Layout>} />
            <Route path="/pagenotfound" element={<Layout><Pagenotfound /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/login" element={<Loginsignup />} />
            <Route path="/orderdetails/:orderId" element={<Layout><OrderDetails /></Layout>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp-verification" element={<OtpVerification />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/user-profile" element={<Layout><Userprofile /></Layout>} />
            <Route path="/cancellation-policy" element={<Layout><Cancellation /></Layout>} />
            {/* Pass specific category products */}
            <Route path="/lollipops" element={<Layout><Lollipop products={lollipopProducts} loading={loading} error={error} /></Layout>} />
            <Route path="/candies" element={<Layout><Candy products={candyProducts} loading={loading} error={error} /></Layout>} />
            <Route path="/toffees" element={<Layout><Toffee products={toffeeProducts} loading={loading} error={error} /></Layout>} />
            <Route path="/premia" element={<Layout><Premia products={premiaProducts} loading={loading} error={error} /></Layout>} />
            <Route path="/profile" element={<Layout><ProfilePage /></Layout>} />
            <Route path="/diwali-special-combo" element={<Layout><RakhiSpecialCombo products={rakhiSpecialComboProducts} loading={loading} error={error} /></Layout>} />
          </Routes>
        </Router>
      )}
      <Toaster />
    </>
  );
}

export default App;
